import { classNames, zodiacBetArr } from "../../../../../tool";
import Number from "../../../../../components/number";
import styles from "../index.module.scss";
export default function TX(props) {
  const { plays, selectPlays, onBet, playOddInfo, firstPlay, secondPlay } =
    props;
  return (
    <div className={styles.playContainer}>
      {plays.map((item, index) => {
        const active =
          selectPlays.findIndex((i) => i.code === item.code) !== -1;
        return (
          <div
            key={index}
            className={classNames(
              styles.TX,
              styles.playItem,
              active ? styles.active : ""
            )}
            onClick={() => onBet(item)}
          >
            <div className={styles.leftName}>
              <div className={styles.name}>{item.name}</div>
              <div className={styles.odds}>
                {
                  playOddInfo[
                    `LHC_${firstPlay.code}_${
                      secondPlay.code || firstPlay.code
                    }${item.code}${zodiacBetArr[index].length > 4 ? "0" : ""}`
                  ]
                }
              </div>
            </div>
            <div className={styles.rightNumber}>
              {zodiacBetArr[index].map((it, idx) => {
                return (
                  <Number
                    active={active}
                    key={idx}
                    number={it}
                    width={"7.556rem"}
                    height={"7.556rem"}
                    fontSize={"3.551rem"}
                  />
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}
